
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 27 44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23 43.9H3.4c-1.9 0-3.4-1.5-3.4-3.4V3.4C0 1.5 1.5 0 3.4 0H23c1.9 0 3.4 1.5 3.4 3.4v37.1c.1 1.9-1.5 3.4-3.4 3.4zM3.4 2.1c-.7 0-1.3.6-1.3 1.3v37.1c0 .7.6 1.3 1.3 1.3H23c.7 0 1.3-.6 1.3-1.3V3.4c0-.7-.6-1.3-1.3-1.3H3.4z","fill":"#333"}}),_c('path',{attrs:{"d":"M13.2 39.4a2.5 2.5 0 100-5 2.5 2.5 0 000 5z","fill":"#333"}})])
          )
        }
      }
    